<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item prop="deviceNo" label="设备编号">
                        <el-select v-model="form.deviceNo" clearable placeholder="请选择" style="width:230px;">
                            <el-option
                                v-for="item in devices"
                                :key="item.deviceNo"
                                :label="item.deviceNo"
                                :value="item.deviceNo">
                                <span style="float: right; color: #8492a6; font-size: 13px">&nbsp;&nbsp;{{ item.deviceNo }}-{{ item.address }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="pushDeviceNo" label="推送设备编号">
                        <el-input v-model="form.pushDeviceNo" maxlength="50" style="width:230px;"></el-input>
                    </el-form-item>

                     <el-form-item prop="remark" label="备注">
                        <el-input
                            type="textarea"
                            style="width:230px;"
                            placeholder="请输入备注"
                            v-model="form.remark"
                            maxlength="100"
                            show-word-limit>
                        </el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    deptId:"",
                    deviceNo:"",
                    pushDeviceNo:"",
                    remark:""
                },
                rules: {
                    deviceNo: [
                        { required: true, message: '请输入设备编号', trigger: 'blur' }
                    ],
                    pushDeviceNo: [
                        { required: true, message: '请输入推送设备编号', trigger: 'blur' }
                    ]
                },
                devices:[]
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data){
                console.log(JSON.stringify(data));
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.getDevices();
                this.form.id=data.id;
                this.form.deptId=data.deptId;
                this.form.deviceNo=(data.deviceNo == null?"":data.deviceNo);
                this.form.pushDeviceNo=(data.pushDeviceNo == null?"":data.pushDeviceNo);
                this.form.remark=data.remark;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            // 获取设备
            getDevices(){
                let url  = this.listDeviceSelectUrl;
                let data = {
                    commonSign:1,
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.devices = res.data.list; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(valid){

                        let url = this.setBindDeviceUpdateUrl;
                        let data = {
                            id:this.form.id,
                            deptId:this.form.deptId,
                            deviceNo:this.form.deviceNo,
                            pushDeviceNo:this.form.pushDeviceNo,
                            remark:this.form.remark
                        };

                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/set/deviceBind/Update.vue